export default {
  myLocation: {
    myPositionToolTip: 'Activați locația pentru a vă afișa poziția și pentru a găsi mai ușor locurile din apropiere',
    onlyOnce: 'O singură dată',
    continuouslyLocation: 'Actualizați-vă poziția la fiecare 2 secunde',
    showCurrentLocation: 'Faceți clic pentru a afișa locația dumneavoastră curentă',
    yourCurrentLocation: 'Locația dumneavoastră actuală',
    continuously: 'Continuu',
    onlyOnceLocation: 'Dobândește-ți poziția o singură dată',
    stopShowingCurrentLocation: 'Faceți clic pentru a nu mai afișa locația dumneavoastră curentă',
  }
}
